import React from "react";

const Copyright = () => {
  return (
    <footer className="text-xs text-neutral-500">
      Copyright © 2025 Rally
    </footer>
  );
};

export default Copyright;
